'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _urls = require('../../urls');

var _urls2 = _interopRequireDefault(_urls);

var _menuResponsive = require('../../initializers/menuResponsive');

var _menuResponsive2 = _interopRequireDefault(_menuResponsive);

var _CartItem = require('../components/CartItem');

var _CartItem2 = _interopRequireDefault(_CartItem);

var _MidCart = require('../components/MidCart');

var _MidCart2 = _interopRequireDefault(_MidCart);

var _storageProvider = require('../../storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _ajaxHelper = require('../../libraries/ajaxHelper');

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var Cart = function (_Component) {
    (0, _inherits3.default)(Cart, _Component);
    (0, _createClass3.default)(Cart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var initialState = JSON.parse(this._root.parentNode.attributes['data-component-props'].value);
            this._root.parentNode.removeAttribute('data-component-props');
            this.props.update(initialState.cart);
            this.props.loadData(initialState.cart);
        }
    }]);

    function Cart(props) {
        (0, _classCallCheck3.default)(this, Cart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Cart.__proto__ || (0, _getPrototypeOf2.default)(Cart)).call(this, props));

        _this.carouselItems = _this.deliveryTypeLimits = _this.freeItems = [];
        _this.loadAllMidCartItems();
        return _this;
    }

    (0, _createClass3.default)(Cart, [{
        key: 'loadAllMidCartItems',
        value: function loadAllMidCartItems() {
            this.loadMidCartItems('carouselItems', '/Product/BestsellersJson');
            // this.loadMidCartItems('deliveryTypes', '/MidCart/GetAvailableDeliveryTypes', 20);
            this.loadMidCartItems('deliveryTypeLimits', '/MidCart/GetFreeDeliveryLimit', 20);
            this.loadMidCartItems('freeItems', '/MidCart/GetAvailableFreeProducts', 5);
        }
    }, {
        key: 'loadMidCartItems',
        value: function loadMidCartItems(responseProperty, endpointUrl) {
            var cacheValidity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

            var component = this;
            var storageKey = responseProperty + '_key';
            component[responseProperty] = _storageProvider2.default.getValue(storageKey, cacheValidity);
            if (!component[responseProperty]) {
                var ajaxHelper = new _ajaxHelper2.default();
                ajaxHelper.sendRequest(endpointUrl, function (httpRequest, responseObject) {
                    if (!responseObject || !responseObject.result) return;
                    component[responseProperty] = responseObject.result;
                    _storageProvider2.default.setValue(storageKey, responseObject.result);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var cart = this.props.cart;

            if (!cart.totalPrice) {
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'emptyCart', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement('div', { className: 'cart--loading' })
                );
            }

            if (cart.items.length > 0) {
                setTimeout(function () {
                    $("#cartMenu").find(".scrollPane").mCustomScrollbar({
                        advanced: {
                            updateOnContentResize: true
                        }, scrollButtons: {
                            enable: false
                        }
                    });

                    // reinit menu prevent namespace falling
                    (0, _menuResponsive2.default)();
                }, 0);
            }

            if (cart.items.length === 0) {
                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'emptyCart', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: (0, _urls2.default)('cart') },
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _linksoftAlbatros.formatPrice)(0, _linksoftAlbatros.PriceType.CartTotalPrice)
                        ),
                        _react2.default.createElement('i', { className: 'icon--cart' })
                    )
                );
            } else {
                var itemsTotalAmount = 0;
                cart.items.forEach(function (i) {
                    return itemsTotalAmount += i.amount;
                });

                return _react2.default.createElement(
                    'div',
                    { id: 'cartMenu', className: 'dropdown', ref: function ref(e) {
                            return _this2._root = e;
                        } },
                    _react2.default.createElement(
                        'a',
                        { href: (0, _urls2.default)('cart'), className: 'dropdown-toggle dropdown-toggle--click', 'data-toggle': 'dropdown' },
                        _react2.default.createElement(
                            'strong',
                            { className: 'mini-c__money' },
                            Resx.App.CartSummaryFormat.replace('{0}', cart.items.length).replace('{1}', (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice))
                        ),
                        _react2.default.createElement(
                            'i',
                            { className: 'icon--cart' },
                            _react2.default.createElement(
                                'span',
                                { className: 'mini-c__info' },
                                itemsTotalAmount
                            )
                        )
                    ),
                    _react2.default.createElement(_MidCart2.default, { carouselItems: this.carouselItems, deliveryTypeLimits: this.deliveryTypeLimits, freeItems: this.freeItems }),
                    _react2.default.createElement(
                        'div',
                        { className: 'dropdown__content mini-c__wrap' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            Resx.App.ShoppingCart
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'miniCartTable scrollPane' },
                            _react2.default.createElement(
                                'div',
                                { className: 'mini-c__table' },
                                cart.items.slice(0, cart.miniCartMaxItems).map(function (item) {
                                    return _react2.default.createElement(_CartItem2.default, { key: item.id, data: item, canChangeCart: cart.canChangeCart });
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mini-c__total' },
                            _react2.default.createElement(
                                'a',
                                { href: (0, _urls2.default)('cart'), className: 'pull-left btn btn--sm' },
                                Resx.App.ToTheOrder
                            ),
                            _react2.default.createElement(
                                'h3',
                                null,
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    Resx.App.Total,
                                    ':'
                                ),
                                ' ',
                                (0, _linksoftAlbatros.formatPrice)(cart.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                            )
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: '#', className: 'mini-c__close', onClick: this.closeMiniCart },
                            _react2.default.createElement('i', {
                                className: 'icon--cross' })
                        )
                    )
                );
            }
        }
    }]);
    return Cart;
}(_react.Component);

Cart.propTypes = {
    cart: _propTypes2.default.object.isRequired,

    update: _propTypes2.default.func.isRequired,
    empty: _propTypes2.default.func.isRequired,
    loadData: _propTypes2.default.func.isRequired,
    submitChanges: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
    return {
        cart: state.cart
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    update: _actions2.default.update,
    empty: _actions2.default.empty,
    loadData: _actions2.default.loadData,
    submitChanges: _actions2.default.submitChanges
})(Cart);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart.js
// module id = 1040
// module chunks = 0